export default __webpack_public_path__ + "static/media/overview.49b7680d.svg";